import { render } from "./TabsRoot.vue?vue&type=template&id=5121ba3e&scoped=true&ts=true"
import script from "./TabsRoot.vue?vue&type=script&lang=ts"
export * from "./TabsRoot.vue?vue&type=script&lang=ts"

import "./TabsRoot.vue?vue&type=style&index=0&id=5121ba3e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/houseme-UI/houseme-UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5121ba3e"]])

export default __exports__